// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"f3683b48","132":"b2b2e40b","256":"d4b1b3f7","432":"9a7489d4","440":"80a2af07","712":"c95ae3e5","784":"1abd50c6","976":"07333730","980":"9a0e1df3"}[chunkId] + ".chunk.js";
};